import React, { useState, useEffect } from 'react';

import { useGetPeakHeartRate } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	getChartMaxValue,
	getChartMinValue,
	increaseOrDecreaseMaxYThreshold,
} from './utils/chartHelpers';
import {
	defaultConfig,
	ticksCallbackBPM,
	tooltipCallbackBPM,
	styledChartElements,
} from './utils/customViewChart';

const PeakHeartRate = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: heartRateData, loading } = useGetPeakHeartRate();
	const isDataAvailable = heartRateData?.data && heartRateData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(heartRateData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [heartRateData]);

	const handleChartConfig = () => {
		let minY = defaultChartAxisValues[chartsKey.peakHeartRate].minY;
		let maxY = defaultChartAxisValues[chartsKey.peakHeartRate].maxY;

		const minValueOfY = getChartMinValue(heartRateData.data, 'value');
		const maxValueOfY = getChartMaxValue(heartRateData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.xl;
		}

		if (minValueOfY && minValueOfY <= minY) {
			minY = minValueOfY - increaseOrDecreaseMaxYThreshold.xl;
		}

		const config = {
			...defaultConfig,
			plugins: {
				...defaultConfig.plugins,
				tooltip: {
					...defaultConfig.plugins.tooltip,
					callbacks: { label: tooltipCallbackBPM },
				},
			},
			elements: styledChartElements(heartRateData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
					ticks: {
						...defaultConfig.scales.y.ticks,
						callback: ticksCallbackBPM,
					},
				},
			},
		};

		setChartConfig(config);
	};

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	return (
		<ChartModal
			loading={loading}
			data={getChartData}
			labelsData={labelsData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default PeakHeartRate;
